import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  grafanaFullData: any;
  grafanaSubstanceFullData: any;
  singlegrafanaSubstanceFullScrnData: any;
  isLoading:boolean;
  viewDialogLoader:boolean;
}

const initialState: InitialState = {
  grafanaFullData: {},
  grafanaSubstanceFullData: {},
  singlegrafanaSubstanceFullScrnData: {},
  isLoading:false,
  viewDialogLoader:false
};

const newGrafanaSlice = createSlice({
  name: "newGrafana",
  initialState,
  reducers: {
    setGrafanaFullData: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => ({
      ...state,
      grafanaFullData: action.payload,
    }),
    setGrafanaSubstanceFullData: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => ({
      ...state,
      grafanaSubstanceFullData: action.payload,
    }),

    setSingleGrafanaSubstanceFullScrnData: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => ({
      ...state,
      singlegrafanaSubstanceFullScrnData: action.payload,
    }),
    setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: action.payload,
      }
    },
    setviewDialogLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => {
      return {
        ...state,
        viewDialogLoader: action.payload,
      }
    },

  },
});

export const { setGrafanaFullData, setGrafanaSubstanceFullData, setSingleGrafanaSubstanceFullScrnData, setLoader , setviewDialogLoader } = newGrafanaSlice.actions;

export default newGrafanaSlice.reducer;
